import PropTypes from 'prop-types';
import React from 'react';


const SnippetAd = ({ color, handleClick, image, isSerp, name, subtitle, t, title }) => (
  <a className={ `snippet-ad ${isSerp ? '-serp-ad' : '-seo-ad'}` } onClick={ handleClick }>
    <div className="snippet-ad__header__image" style={ { backgroundImage: `url('${image}')` } }>
      <p className="snippet-ad__header__text">
        { t('Sponsored') }
      </p>
    </div>
    <div className="snippet-ad__body">
      <div className="snippet-ad__body-left">
        <div className="snippet-ad__body-left__text">
          <p className="snippet-ad__body-left__text__title">
            { title }
          </p>
          <p className="snippet-ad__body-left__text__subtitle">
            { subtitle }
          </p>
        </div>
      </div>
      <div className="snippet-ad__body-right">
        <img alt="Logo" className="snippet-ad__body-right__image" src={ `https://static.100r.systems/img/inline-ads/${name}_logo.png` } />
        <button className="snippet-ad__footer__button" style={ { backgroundColor: color } } type="button">
          { t('Check offers') }
        </button>
      </div>
      <div className="snippet-ad__body-bottom">
        <button className="snippet-ad__footer__button" style={ { backgroundColor: color } } type="button">
          { t('Check offers') }
        </button>
      </div>
    </div>
  </a>
);

SnippetAd.defaultProps = {
  handleClick: () => {},
  isSerp: true,
};

SnippetAd.propTypes = {
  color: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  image: PropTypes.string.isRequired,
  isSerp: PropTypes.bool,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default SnippetAd;
